import { render, staticRenderFns } from "./Costo.vue?vue&type=template&id=3197a3da&scoped=true"
import script from "./Costo.vue?vue&type=script&lang=js"
export * from "./Costo.vue?vue&type=script&lang=js"
import style0 from "./Costo.vue?vue&type=style&index=0&id=3197a3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3197a3da",
  null
  
)

export default component.exports